import { gsap } from 'gsap';

const sectionEl = document.querySelector('.l-section--news-content');
if (sectionEl) {
  const fromSamePage = (() => {
    if (!document.referrer) return false;
    try {
      const ref = new URL(document.referrer);
      return ref.origin === location.origin && ref.pathname.startsWith('/news');
    } catch {
      return false;
    }
  })();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    gsap.set(sectionEl, { opacity: 1 });
  } else {
    gsap.to(sectionEl, {
      opacity: 1,
      ease: 'power3.out',
      duration: fromSamePage ? 0.2 : 0.8,
      delay: fromSamePage ? 0 : 0.2,
    });
  }

  const titleEl = document.querySelector('.js-page-title-en');
  const subtitleEl = document.querySelector('.js-page-title-ja');

  const navigateWithFade = url => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      location.href = url;
      return;
    }
    gsap.to(sectionEl, {
      opacity: 0,
      duration: 0.2,
      ease: 'power3.in',
      onComplete: () => {
        location.href = url;
      },
    });
  };

  document.querySelectorAll('.c-news-filter__categories a').forEach(link => {
    link.addEventListener('click', e => {
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.defaultPrevented) return;
      if (link.hasAttribute('download')) return;
      if (link.target && link.target !== '_self') return;
      const href = link.getAttribute('href');
      if (!href) return;
      e.preventDefault();
      navigateWithFade(href);
    });
  });

  const yearSelect = document.getElementById('js-year-select');
  if (yearSelect) {
    yearSelect.addEventListener('change', () => {
      const url = yearSelect.value;
      if (!url) return;
      try {
        const urlObj = new URL(url, window.location.origin);
        if (urlObj.origin === window.location.origin) {
          navigateWithFade(urlObj.href);
        }
      } catch {
        // invalid URL
      }
    });
  }
}
